// extracted by mini-css-extract-plugin
export default {"hero-image":"content_hero-image__A6M9Z","cta-box":"content_cta-box__Oh9YI","add-section":"content_add-section__K42K4"};